import React, { useState, useEffect, createRef } from 'react';
import styled from 'styled-components';
import Tooltip from '@commoncomponents/frontend-components/dist/components/Tooltip';
import AvatarPlaceholder from '../AvatarPlaceholder';
export const AvatarWrapper = styled.div `
  display: ${(props) => (props.emailText ? 'flex' : 'block')};
  align-items: flex-start;
  width: 100%;
  flex-direction: column;
`;
export const ContentWithPlaceholder = styled.div `
  display: flex;
  align-items: center;
`;
export const UserDetails = styled.div `
  display: ${(props) => (props.emailText ? 'flex' : 'block')};
  flex-direction: column;
  margin-left: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  .tooltip-content {
    height: 21px;
  }
`;
export const NameText = styled.span `
  margin: 0;
  font-size: ${(props) => props.theme.fontSmall};
  color: ${(props) => props.theme.navyBlue};
  font-weight: ${(props) => props.theme.bold};
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const EmailText = styled.span `
  font-size: ${(props) => props.theme.fontXXSmall};
  color: ${(props) => props.theme.navyBlue};
  word-break: break-all;
  line-height: 21px;
`;
export const TextWithTooltipWrapper = styled.span `
  display: inline-flex;
  flex-direction: row;
  max-width: 260px;

  @media (max-width: 568px) {
    max-width: 200px;
  }

  @media (max-width: 446px) {
    max-width: 110px;
  }
`;
export const NameWithTooltipText = styled(NameText) `
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
export const EmailWithTooltipText = styled(EmailText) `
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
export const PhoneText = styled(EmailText) `
  padding-left: 40px;
`;
const Avatar = ({ className, givenName, surname, email, nameText, youText, emailText, phoneText, isCurrentUser, showNameTooltip, showEmailTooltip, showAvatarPlaceholder = true, testerProps = {}, }) => {
    const nameTextRef = createRef();
    const emailTextRef = createRef();
    const [isNameTextOverflowing, setIsNameTextOverflowing] = useState(false);
    const [isEmailTextOverflowing, setIsEmailTextOverflowing] = useState(false);
    useEffect(() => {
        if (nameTextRef.current) {
            const hasOverflowing = nameTextRef.current.offsetWidth !== nameTextRef.current.scrollWidth;
            setIsNameTextOverflowing(hasOverflowing);
        }
        if (emailTextRef.current) {
            const hasOverflowing = emailTextRef.current.offsetWidth !== emailTextRef.current.scrollWidth;
            setIsEmailTextOverflowing(hasOverflowing);
        }
    }, []);
    return (React.createElement(AvatarWrapper, { className: `avatar ${className}`, emailText: emailText },
        React.createElement(ContentWithPlaceholder, null,
            Boolean(showAvatarPlaceholder) && (React.createElement(AvatarPlaceholder, { givenName: givenName, surname: surname, email: email })),
            React.createElement(UserDetails, { emailText: emailText },
                showNameTooltip ? (React.createElement(Tooltip, { disabled: !isNameTextOverflowing, maxWidth: 500, message: nameText || `${givenName} ${surname}`, popperOptions: {
                        disabled: true,
                    }, preferredPlacement: "top", theme: "dark", hasInteractiveContent: true },
                    React.createElement(TextWithTooltipWrapper, { className: "avatar-name-wrapper" },
                        React.createElement(NameWithTooltipText, Object.assign({ id: "avatar_name_text" }, testerProps, { className: "avatar-name", ref: nameTextRef }),
                            nameText || `${givenName} ${surname} `,
                            isCurrentUser && youText)))) : (React.createElement(NameText, Object.assign({ id: "avatar_name_text" }, testerProps, { className: "avatar-name", ref: nameTextRef }),
                    nameText || `${givenName} ${surname} `,
                    isCurrentUser && youText)),
                emailText &&
                    (showEmailTooltip ? (React.createElement(Tooltip, { disabled: !isEmailTextOverflowing, maxWidth: 500, hasInteractiveContent: true, message: emailText, popperOptions: {
                            disabled: true,
                        }, preferredPlacement: "top", theme: "dark" },
                        React.createElement(TextWithTooltipWrapper, { className: "avatar-email-wrapper" },
                            React.createElement(EmailWithTooltipText, { className: "avatar-email", ref: emailTextRef }, emailText)))) : (React.createElement(EmailText, { className: "avatar-email" }, emailText))))),
        phoneText && React.createElement(PhoneText, { className: "avatar-phone" }, phoneText)));
};
Avatar.defaultProps = {
    className: '',
    showUserDetails: true,
};
export default Avatar;
